import * as req from 'api/actions';
import * as c from './constant';

// OTP settings GET
export const getOTPSettings = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_OTP_SETTINGS,
    `/api/v1/administrators/otp_settings`,
    payload,
    callback
  );

// OTP settings SHOW (single)
export const showOTPSettings = (id, payload, callback) =>
  req.item(
    c.SHOW_OTP_SETTINGS,
    // `api/v1/administrators/billing_import/${id}`,
    `/api/v1/administrators/otp_settings/${id}`,
    payload,
    callback
  );

// OTP settings UPDATE
export const updateOTPSettings = (id, payload, callback) =>
  req.update(
    c.UPDATE_OTP_SETTINGS,
    `/api/v1/administrators/otp_settings/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );
